/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Asset } from './Asset';
import {
    AssetFromJSON,
    AssetFromJSONTyped,
    AssetToJSON,
    AssetToJSONTyped,
} from './Asset';
import type { EVMChain } from './EVMChain';
import {
    EVMChainFromJSON,
    EVMChainFromJSONTyped,
    EVMChainToJSON,
    EVMChainToJSONTyped,
} from './EVMChain';

/**
 * Represents a grouping of NftTrackers. Primarily used to combine multiple Nft Collections that span multiple contracts. It also is the primary space to hold the metadata to be displayed to the user.
 * @export
 * @interface NftGrouping
 */
export interface NftGrouping {
    /**
     * 
     * @type {string}
     * @memberof NftGrouping
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof NftGrouping
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof NftGrouping
     */
    updatedAt: number;
    /**
     * 
     * @type {string}
     * @memberof NftGrouping
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof NftGrouping
     */
    sortPriority?: number;
    /**
     * 
     * @type {string}
     * @memberof NftGrouping
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof NftGrouping
     */
    discordUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof NftGrouping
     */
    twitterUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof NftGrouping
     */
    websiteUrl?: string;
    /**
     * 
     * @type {Asset}
     * @memberof NftGrouping
     */
    hero?: Asset;
    /**
     * 
     * @type {Asset}
     * @memberof NftGrouping
     */
    icon?: Asset;
    /**
     * 
     * @type {boolean}
     * @memberof NftGrouping
     */
    disabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NftGrouping
     */
    isGuildGrouping?: boolean;
    /**
     * 
     * @type {number}
     * @memberof NftGrouping
     */
    numOfMembers?: number;
    /**
     * 
     * @type {number}
     * @memberof NftGrouping
     */
    rank?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof NftGrouping
     */
    categories?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof NftGrouping
     */
    totalPoints?: number;
    /**
     * 
     * @type {Array<EVMChain>}
     * @memberof NftGrouping
     */
    chains?: Array<EVMChain>;
}

/**
 * Check if a given object implements the NftGrouping interface.
 */
export function instanceOfNftGrouping(value: object): value is NftGrouping {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function NftGroupingFromJSON(json: any): NftGrouping {
    return NftGroupingFromJSONTyped(json, false);
}

export function NftGroupingFromJSONTyped(json: any, ignoreDiscriminator: boolean): NftGrouping {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'name': json['name'],
        'sortPriority': json['sortPriority'] == null ? undefined : json['sortPriority'],
        'description': json['description'] == null ? undefined : json['description'],
        'discordUrl': json['discordUrl'] == null ? undefined : json['discordUrl'],
        'twitterUrl': json['twitterUrl'] == null ? undefined : json['twitterUrl'],
        'websiteUrl': json['websiteUrl'] == null ? undefined : json['websiteUrl'],
        'hero': json['hero'] == null ? undefined : AssetFromJSON(json['hero']),
        'icon': json['icon'] == null ? undefined : AssetFromJSON(json['icon']),
        'disabled': json['disabled'] == null ? undefined : json['disabled'],
        'isGuildGrouping': json['isGuildGrouping'] == null ? undefined : json['isGuildGrouping'],
        'numOfMembers': json['numOfMembers'] == null ? undefined : json['numOfMembers'],
        'rank': json['rank'] == null ? undefined : json['rank'],
        'categories': json['categories'] == null ? undefined : json['categories'],
        'totalPoints': json['totalPoints'] == null ? undefined : json['totalPoints'],
        'chains': json['chains'] == null ? undefined : ((json['chains'] as Array<any>).map(EVMChainFromJSON)),
    };
}

export function NftGroupingToJSON(json: any): NftGrouping {
    return NftGroupingToJSONTyped(json, false);
}

export function NftGroupingToJSONTyped(value?: NftGrouping | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'name': value['name'],
        'sortPriority': value['sortPriority'],
        'description': value['description'],
        'discordUrl': value['discordUrl'],
        'twitterUrl': value['twitterUrl'],
        'websiteUrl': value['websiteUrl'],
        'hero': AssetToJSON(value['hero']),
        'icon': AssetToJSON(value['icon']),
        'disabled': value['disabled'],
        'isGuildGrouping': value['isGuildGrouping'],
        'numOfMembers': value['numOfMembers'],
        'rank': value['rank'],
        'categories': value['categories'],
        'totalPoints': value['totalPoints'],
        'chains': value['chains'] == null ? undefined : ((value['chains'] as Array<any>).map(EVMChainToJSON)),
    };
}

